<template>
<v-app>
<div class="main-container">

    <div class="top-container">
      <v-img :src="require('@/assets/logo.png')"
          class="logo centered-element"
          contain
        ></v-img>
    </div>

    <div class="bottom-container footer-container">

      <v-card
        flat
        tile
        color="primary"
        class="text-center centered-element"
        style="width:100%;"
      >

      <v-card-text class="text-center white--text pt-2 mt-4" >
        <router-link to="/hvh">
          <v-img
          :src="require('../assets/img/hvh-home.png')"
          class="hvh-home"
          contain
        ></v-img>
      </router-link>
        </v-card-text>

      <v-card-text class="text-center white--text pt-1" >
        <a href="https://substack.com/@yasinantjeaalillou" target="_blank">
          <v-img
          :src="require('../assets/img/banner-rd.png')"
          class="rd-home"
          contain
        ></v-img>
        </a>
      </v-card-text>

        <v-card-text class="pt-2">
        <v-btn small
        color="white"
            class="mx-3"
            fab
            href="mailto:yasin@aalillou.be"
          >
            <v-icon size="20px">mdi-mail</v-icon>
          </v-btn>
          <v-btn small
        color="white"
            class="mx-3"
            fab
            href="https://www.instagram.com/yasinantjeaalillou/"
          >
            <v-icon size="20px">mdi-instagram</v-icon>
          </v-btn>
        </v-card-text>
  

  
        <v-divider></v-divider>
  
        <v-card-text class="white--text">
          &copy;2025 — <strong>Antje.be</strong>
        </v-card-text>
      </v-card>

    </div>
        
</div>
</v-app>
</template>

<script>
  export default {
    name: 'Home',
    components: {},
  }
</script>
<style lang="scss">

.main-container {
  flex: 0 1 100%;
  display: flex;
  height: 100%;
  flex-wrap: wrap;
  align-items: flex-start;
}

.top-container {
  flex: 0 0 100%;
  max-height: 40%;
  min-height: 40%;
  max-width: 100%;
  overflow: hidden;
  position: relative;
}

.bottom-container {
  flex: 0 0 100%;
  max-height: 60%;
  min-height: 60%;
  max-width: 100%;
  //overflow: hidden;
  position: relative;
}

.footer-container {
  background: #000000;
}

  .logo {
      max-height: 300px;
  }
  .hvh-home  {
      max-height: 150px;
  }
  .rd-home  {
      max-height: 80px;
      img {

      }
  }
  @media only screen and (min-width: 320px) and (max-width: 667px) and (orientation: portrait) {
    .logo {
      max-height: 150px;
    }
    .hvh-home  {
      max-height: 100px;
    }
  }
  .logo-container {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
  .centered-element {
  margin: 0;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
</style>

